import { create } from "zustand";

interface PWARewardStore {
  isOpenModalPWAReward: boolean;
  setIsOpenModalPWAReward: (bool: boolean) => void;
}

export const usePWARewardStore = create<PWARewardStore>((set) => ({
  isOpenModalPWAReward: false,
  setIsOpenModalPWAReward: (isOpenModalPWAReward: boolean) => set({ isOpenModalPWAReward }),
}));
